import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";

import { NgChanges } from "@app/shared/model/ng-changes.model";

/**
 * @description The payload for the emitted event for search
 * @interface SearchPayload
 */
export interface SearchPayload {
    searchTerm: string;
}
@Component({
    selector: "clare-search",
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./clare-search.component.html",
    styleUrls: ["./clare-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareSearchComponent implements OnChanges, OnInit, OnDestroy {
    @Output() private searchDataHandler = new EventEmitter<SearchPayload>();

    @Input() placeholder = "Search";
    @Input() initialValue!: string;
    @Input() isWhiteCharacterIgnored = false;

    searchForm: FormGroup = this.formBuilder.group({
        search: [],
    });

    randomIdSuffix = Math.random();

    private unsubscribe$ = new Subject();

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.searchForm.controls["search"].valueChanges
            .pipe(takeUntil(this.unsubscribe$), debounceTime(300), distinctUntilChanged())
            .subscribe(_ => {
                this.search();
            });
    }

    ngOnChanges(changes: NgChanges<ClareSearchComponent>): void {
        if (changes.initialValue) {
            this.searchForm.patchValue({
                search: changes.initialValue.currentValue,
            });
            this.search();
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    /**
     * @description Emits an event to the parent when the search input changes
     */
    search() {
        let searchTerm: string = this.searchForm.value.search || "";
        if (this.isWhiteCharacterIgnored) {
            searchTerm = searchTerm.trim();
        }
        this.searchDataHandler.emit({ searchTerm });
    }
}
